import { useEffect } from 'react';

const DEFAULT_TITLE = 'RunPort NFT - マラソン完走証をブロックチェーンに刻む';

/**
 * 環境に応じたプレフィックスを取得
 */
function getEnvironmentPrefix(): string {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') return '【localhost】';
  if (hostname.startsWith('dev-nft.')) return '【Dev】';
  if (hostname.startsWith('demo-nft.')) return '【Demo】';
  return '';
}

/**
 * ドキュメントタイトルを動的に設定するフック
 * 環境に応じたプレフィックスが自動付与される
 * @param title タイトル（省略時はデフォルト）
 */
export function useDocumentTitle(title?: string) {
  useEffect(() => {
    const prefix = getEnvironmentPrefix();
    document.title = prefix + (title || DEFAULT_TITLE);

    return () => {
      document.title = prefix + DEFAULT_TITLE;
    };
  }, [title]);
}
